export default "__VITE_ASSET__bf7f009f__"